import { toast, type ToastOptions } from "react-toastify";

const sharedOptions: ToastOptions = {
  position: "top-right",
  autoClose: 3500,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

export const dashboardToast = {
  success(message: string) {
    return toast.success(message, {
      ...sharedOptions,
      className: "dashboard-toast dashboard-toast--success",
      bodyClassName: "dashboard-toast__body",
      progressClassName: "dashboard-toast__progress dashboard-toast__progress--success",
    });
  },

  error(message: string) {
    return toast.error(message, {
      ...sharedOptions,
      className: "dashboard-toast dashboard-toast--error",
      bodyClassName: "dashboard-toast__body",
      progressClassName: "dashboard-toast__progress dashboard-toast__progress--error",
    });
  },

  warning(message: string) {
    return toast.warning(message, {
      ...sharedOptions,
      className: "dashboard-toast dashboard-toast--warning",
      bodyClassName: "dashboard-toast__body",
      progressClassName: "dashboard-toast__progress dashboard-toast__progress--warning",
    });
  },

  info(message: string) {
    return toast.info(message, {
      ...sharedOptions,
      className: "dashboard-toast dashboard-toast--info",
      bodyClassName: "dashboard-toast__body",
      progressClassName: "dashboard-toast__progress dashboard-toast__progress--info",
    });
  },

  dismiss() {
    return toast.dismiss();
  },
};
